import React, { useState } from 'react';

import { CollapsiblePanel, componentTypes } from '@white-nl/instantsearch-components';

interface Site {
  siteId: string;
  siteName: string;
  groupId: string;
  groupName: string;
}

interface Group {
  id: string;
  name: string;
  sites: Site[];
}

export default function LanguageSelection({
  menu,
  menuSettings,
  additionalData,
}: componentTypes.MenuPanelProps) {
  const { items, refine } = menu;

  const { attribute, panelSettings } = menuSettings;

  const { sites, currentSiteId } = additionalData;

  const [selectedGroupId, setSelectedGroupId] = useState('');

  const loading = items.length === 0;
  if (loading) {
    return null;
  }

  const selectedItem = items.find((item) => item.isRefined) || null;
  if (!selectedItem) {
    const toSelect = items.find((item) => item.value === currentSiteId) || items[0];
    if (toSelect) {
      refine(toSelect.value);
    }
    return null;
  }

  const siteGroups: Record<string, Group> = sites
    .reduce((group: Record<string, Group>, site: Site) => {
      const key = site.groupId;
      if (!group[key]) {
        // eslint-disable-next-line no-param-reassign
        group[key] = {
          id: site.groupId,
          name: site.groupName,
          sites: [],
        };
      }
      if (!site.siteName.toLowerCase().includes('united kingdom')) {
        group[key].sites.push(site);
      }
      return group;
    }, {});

  const groups = Object.values(siteGroups).sort((a, b) => a.name.localeCompare(b.name));

  const selectedGroup = groups
    .find((g) => g.sites.find((s) => s.siteId === selectedItem.value)) || null;
  if (!selectedGroup) {
    return null;
  }

  if (!selectedGroupId) {
    setSelectedGroupId(selectedGroup.id);
    return null;
  }

  return (
    <CollapsiblePanel
      header={panelSettings?.header}
      footer={panelSettings?.footer}
      collapsiblePanelSettings={panelSettings?.collapsiblePanelSettings}
    >
      <select
        className="form-select"
        aria-label={Craft.t('downloads', 'Language selection')}
        value={selectedGroupId}
        onChange={(event) => setSelectedGroupId(event.currentTarget.value)}
      >
        {groups.map((group) => (
          <option key={group.id} value={group.id}>{group.name}</option>
        ))}
      </select>
      <ul className="list-radio">
        {siteGroups[selectedGroupId].sites.map((item) => (
          <li key={item.siteId}>
            <div className="custom-control custom-radio">
              <input
                id={`${attribute}-${item.siteId}`}
                className="custom-control-input"
                type="radio"
                name={attribute}
                disabled={items.filter((i) => i.value === item.siteId).length === 0}
                value={item.siteId}
                checked={selectedItem.value === item.siteId}
                onChange={(event) => refine(event.currentTarget.value)}
              />
              <label htmlFor={`${attribute}-${item.siteId}`} className="custom-control-label">
                {item.siteName.split('-').slice(1).join('-').trim()}
              </label>
            </div>
          </li>
        ))}
      </ul>
    </CollapsiblePanel>
  );
}
